import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ChatBox from "../components/ChatBox";
import MessageBox from "../components/ChatBox/messageBox";
import Drawer from "../components/Drawer";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import {
  ActivationTransferFundsPage,
  ActivationTxnHistoryPage,
  TransferFundsUserPage
} from "../pages/activationWallet";
import AddFunds from "../pages/addFunds";
import {
  AccountStatementPage,
  AutoPoolBonusPage,
  DirectBonusPage,
  GenerationBonusPage,
  LevelBonusPage,
  MangerCommPage,
  MatchingBonus,
  RoiBonusPage
} from "../pages/earning";
import { EditWalletPage, TxnHistoryPage } from "../pages/ebttWallet";
import { FundsTxnHistoryPage, TransferFundsPage } from "../pages/fundsTransfer";
import Home from "../pages/home";
import { DirectTeamPage, MyDownlinePage, MyTreePage } from "../pages/myTeam";
import { SupportTicketPage, TicketHistoryPage } from "../pages/support";
import {
  AccountTopupPage,
  MyTopupHistoryPage,
  TopupHistoryPage
} from "../pages/topup";
import TransHistoryPage from "../pages/transactionHistory";
import {
  MyProfile,
  UpdatePassword,
  UpdateProfile,
  UpdateWallet
} from "../pages/userProfile";
import { ReportStatusPage, WithdrawFundsPage } from "../pages/withdraw";

const Routers = () => {
  // add custom attribute on body tag
  const [show, setShow] = useState(true);
  // message
  const [id, setId] = useState(null);
  const [messageBoxShow, setMessageBoxShow] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const handleOpenChat = (dataType, id) => {
    setOpenChat(dataType);
    setId(id);
    setMessageBoxShow(true);
  };
  return (
    <>
      <BrowserRouter>
        <div className="home_wrapper" show-menu={show ? "false" : "true"}>
          {/* chatting list sidebar */}
          <Drawer
            openDrawer={openChat}
            setOpenDrawer={setOpenChat}
            className="chatting_box"
          >
            <ChatBox setOpenDrawer={handleOpenChat} />
          </Drawer>
          {/* message wrtting box */}
          {messageBoxShow && (
            <MessageBox id={id} setMessageBoxShow={setMessageBoxShow} />
          )}
          {/* sidebar */}
          <div className="sidebar_wrapper">
            <Sidebar />
          </div>
          {!show && (
            <div
              className="menu_backdrop"
              style={{
                position: "fixed",
                backgroundColor: "#0000001c",
                width: "100%",
                height: "100%",
                zIndex: "99",
              }}
              onClick={() => setShow(true)}
            ></div>
          )}
          {/* body container */}
          <div className="body_content_wrapper">
            {/* header */}
            <Header
              setShow={setShow}
              show={show}
              openChat={openChat}
              setOpenChat={setOpenChat}
            />
            <div className="content_wrapper">
              {/* Routers for every page render on the UI */}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/add-funds" element={<AddFunds />} />
                <Route
                  path="/transaction-history"
                  element={<TransHistoryPage />}
                />
                <Route path="/user/my-profile" element={<MyProfile />} />
                <Route
                  path="/user/update-profile"
                  element={<UpdateProfile />}
                />
                <Route path="/user/update-wallet" element={<UpdateWallet />} />
                <Route
                  path="/user/update-password"
                  element={<UpdatePassword />}
                />
                <Route
                  path="/wallet/edit-wallet"
                  element={<EditWalletPage />}
                />
                <Route path="/wallet/txn-wallet" element={<TxnHistoryPage />} />
                <Route path="/team/my-tree" element={<MyTreePage />} />
                <Route path="/team/direct-team" element={<DirectTeamPage />} />
                <Route path="/team/my-downline" element={<MyDownlinePage />} />
                <Route
                  path="/earnings/direct-bonus"
                  element={<DirectBonusPage />}
                />
                <Route
                  path="/earnings/matching-bonus"
                  element={<MatchingBonus />}
                />
                <Route path="/earnings/roi-bonus" element={<RoiBonusPage />} />
                <Route
                  path="/earnings/level-bonus"
                  element={<LevelBonusPage />}
                />
                <Route
                  path="/earnings/generation-bonus"
                  element={<GenerationBonusPage />}
                />
                <Route
                  path="/earnings/auto-pool-bonus"
                  element={<AutoPoolBonusPage />}
                />
                <Route
                  path="/earnings/manager-comm-bonus"
                  element={<MangerCommPage />}
                />
                <Route
                  path="/earnings/account-statement"
                  element={<AccountStatementPage />}
                />
                <Route
                  path="/topup/topup-account"
                  element={<AccountTopupPage />}
                />
                <Route
                  path="/topup/topup-history"
                  element={<TopupHistoryPage />}
                />
                <Route
                  path="/topup/my-topup-history"
                  element={<MyTopupHistoryPage />}
                />
                <Route
                  path="/funds/transfer-funds"
                  element={<TransferFundsPage />}
                />
                <Route
                  path="/funds/txn-history"
                  element={<FundsTxnHistoryPage />}
                />
                <Route
                  path="/activationWallet/transfer-funds"
                  element={<ActivationTransferFundsPage />}
                />
                <Route
                  path="/activationWallet/transfer-funds-to-user"
                  element={<TransferFundsUserPage />}
                />
                <Route
                  path="/activationWallet/txn-history"
                  element={<ActivationTxnHistoryPage />}
                />
                <Route
                  path="/withdraw/withdraw-funds"
                  element={<WithdrawFundsPage />}
                />
                <Route
                  path="/withdraw/reports-status"
                  element={<ReportStatusPage />}
                />
                <Route path="/reward" element={<ReportStatusPage />} />
                <Route
                  path="/support/support-ticket"
                  element={<SupportTicketPage />}
                />
                <Route
                  path="/support/ticket-history"
                  element={<TicketHistoryPage />}
                />
              </Routes>
              <Footer />
            </div>
          </div>
        </div>
      </BrowserRouter>
    </>
  );
};

export default Routers;
